import { formatDate_YMDHMS, roundDateToFloor } from "@/_core/_helpers/_helpers";
import axios from "axios";
import { authHeader } from "@/_helpers";

/**
 * Retrieves valuation data for commodities
 * @param {object} ctx: context variables, must include ctx.currencyNumber and ctx.initCurrencyDate
 */
export function getCommodityValuation(ctx) {
  return axios.get(`${process.env.VUE_APP_GATEWAY_URL}commodities/valuation-inputs`, {
    headers: authHeader(),
    params: {
      format: "json",
      commodity: ctx.currencyNumber,
      last: 1,
      refresh: formatDate_YMDHMS(roundDateToFloor(ctx.initCurrencyDate)),
    },
  });
}

export function getCommodityValuationApiGataway(ctx) {
  return axios.get(`${process.env.VUE_APP_GATEWAY_URL}commodities/valuation-inputs`, {
    headers: authHeader(),
    params: {
      commodity: ctx.currencyNumber,
      format: "json",
      last: 1,
      refresh: formatDate_YMDHMS(roundDateToFloor(ctx.initCurrencyDate)),
    },
  });
}
